import React from 'react';

import RecyclablePacksHeroBanner from './RecyclablePacksHeroBanner';
import { RecyclablePacksHeroBannerData } from './RecyclablePacksHeroBanner/models';

interface RecyclablePacksHeroBannerPropsRaw {
  finishLogo?: { url: string };
  autoDishBrandLogo?: { url: string };
  mainPackshot?: { url: string };
  bgImageDesktop?: { url: string };
  bgImageMobile?: { url: string };
  heading?: string;
  disclaimer?: string;
}

const RecyclablePacksHeroBannerWrapper = (props: RecyclablePacksHeroBannerPropsRaw) => {
  const {
    finishLogo,
    autoDishBrandLogo,
    mainPackshot,
    bgImageDesktop,
    bgImageMobile,
    heading,
    disclaimer,
  } = props;

  const data: RecyclablePacksHeroBannerData = {
    finishLogo,
    autoDishBrandLogo,
    mainPackshot,
    bgImageDesktop,
    bgImageMobile,
    heading,
    disclaimer,
  };

  return <RecyclablePacksHeroBanner data={data} />;
};

RecyclablePacksHeroBannerWrapper.displayName = 'RecyclablePacksHeroBannerWrapper';
export default RecyclablePacksHeroBannerWrapper;
